module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('h1', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.languages.length),
      expression: "languages.length"
    }],
    staticClass: "language-settings"
  }, [_c('h2', [_vm._v("Language")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "manifest-file-language"
    }
  }, [_vm._v("Manifest file language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.language),
      expression: "language"
    }],
    attrs: {
      "id": "manifest-file-language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.language = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languageOptions), function(language) {
    return _c('option', {
      domProps: {
        "value": language.code
      }
    }, [_vm._v(_vm._s(language.name))])
  })), _vm._v(" "), _c('p', [_vm._v("This option requires page reload after change to apply")])]), _vm._v(" "), _c('div', {
    staticClass: "firebase-sync"
  }, [_c('h2', [_vm._v("Sync")]), _vm._v(" "), _c('firebase-auth')], 1), _vm._v(" "), _c('tags-editor')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e6012ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Settings.vue
// module id = 561
// module chunks = 1